import React from 'react'
import { useParams } from 'react-router-dom'
import TelegramAccountBrandingPage from '../../screens/TelegramAccountBrandingPage/TelegramAccountBrandingPage.component'

const TelegramAccountBranding: React.FC = () => {
  const params = useParams()
  return <TelegramAccountBrandingPage telegramAccountUUID={params.uuid as string} />
}

export default TelegramAccountBranding
